import React from 'react'
import { Input } from 'antd-mobile'
import { SearchOutline, CloseOutline } from 'antd-mobile-icons'
import './styles/ChannelPage.css'

const ChannelSearchBar = ({
  searchQuery,
  setSearchQuery,
  handleSearchClick,
  onClose
}) => (
  <div className="channel-search-bar">
    <Input
      type="text"
      placeholder="Search messages..."
      value={searchQuery}
      onChange={val => setSearchQuery(val)}
      autoFocus
      className="channel-search-input"
    />
    <SearchOutline
      className="channel-search-icon"
      onClick={handleSearchClick}
      data-testid="search-submit"
    />
    <CloseOutline
      className="channel-search-close"
      onClick={onClose}
      data-testid="close-search"
    />
  </div>
)

export default ChannelSearchBar
